import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

import * as enums from '../enums'

const DOC = gql`
  query SpaceRecordFunctionalUsage(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $spaceRecordId: ID!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                spaceRecordFunctionalUsage(spaceRecordId: $spaceRecordId) {
                  functionalizationMethodology
                  functionalizations {
                    functionId
                    percent
                  }
                  serviceCenterId
                }
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.select<
  graphql.schema.SpaceRecordFunctionalUsageQuery,
  ents.extra.space.Record.FunctionalUsage,
  'tenant'
>(
  'tenant',
  graphql.transformers.OUT.select(
    'zone',
    graphql.transformers.OUT.select(
      'app',
      graphql.transformers.OUT.select(
        'scenario',
        graphql.transformers.OUT.select(
          'extra',
          graphql.transformers.OUT.select(
            'space',
            graphql.transformers.OUT.select(
              'spaceRecordFunctionalUsage',
              graphql.transformers.OUT.object({
                functionalizationMethodology: graphql.transformers.OUT.nonNull(
                  enums.SPACE_RECORD_FUNCTIONAL_METHODOLOGY,
                ),
                functionalizations: graphql.transformers.OUT.default(
                  graphql.transformers.OUT.list(
                    graphql.transformers.OUT.nonNull(
                      graphql.transformers.OUT.object({
                        functionId: graphql.transformers.OUT.validate(
                          transformers.PASS_THROUGH,
                          ents.extra.space.Function.Id.isId,
                        ),
                        percent: transformers.PASS_THROUGH,
                      }),
                    ),
                  ),
                  [],
                ),
                serviceCenterId: graphql.transformers.OUT.nullable(
                  graphql.transformers.OUT.validate(
                    transformers.PASS_THROUGH,
                    ents.extra.space.ServiceCenter.Id.isId,
                  ),
                ),
              }),
            ),
          ),
        ),
      ),
    ),
  ),
)
export const executor = graphql.createExecutor<
  graphql.schema.SpaceRecordFunctionalUsageQuery,
  ents.extra.space.Record.FunctionalUsage | undefined,
  graphql.schema.SpaceRecordFunctionalUsageQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
